module.exports = __webpack_public_path__ + "img/id-card-back-01.a636c7d3.svg";